export default __webpack_public_path__ + "static/media/BB_14.50bfb322.png";